import action from './action';

const Component = () => import('./Promotions');

export { Component, action };
